import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsHN: CultureInfo = {
  name: 'es-HN',
  displayName: 'Spanish (Honduras)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-HN',
  parent: CultureInfoEs
};
